(function () {

  // -- Helpers ---------------------------------------------------------------

  function buildOptions() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return [];

    const fieldsets = Array.from(picker.querySelectorAll('fieldset.variant-option'));
    const options = [];

    fieldsets.forEach((fieldset) => {
      const name = (
        fieldset.dataset.optionName ||
        fieldset.dataset.option ||
        fieldset.querySelector('legend')?.textContent ||
        ''
      ).toLowerCase().trim();

      const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      const all = radios.map((r) => r.value.toLowerCase().trim()).filter(Boolean);
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      const selected = (checked?.value || '').toLowerCase().trim();

      if (selected && all.length) {
        options.push({ name, selected, all });
      }
    });

    return options;
  }

  function altContainsValue(alt, value) {
    const escaped = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(^|[\\s,_\\-])' + escaped + '([\\s,_\\-]|$)').test(alt);
  }

  // -- Core filter -----------------------------------------------------------

  function applyFilter(items, options) {
    if (!items.length || !options.length) {
      items.forEach((item) => item.classList.remove('variant-media-hidden'));
      return;
    }

    const getAlt = (item) => (item.querySelector('img')?.alt || '').toLowerCase().trim();

    const dimensionActive = options.map(() => false);

    items.forEach((item) => {
      const alt = getAlt(item);
      options.forEach((opt, i) => {
        if (opt.all.some((v) => alt === v || altContainsValue(alt, v))) {
          dimensionActive[i] = true;
        }
      });
    });

    items.forEach((item) => {
      const alt = getAlt(item);
      let show = true;

      options.forEach((opt, i) => {
        if (!dimensionActive[i]) return;
        const isTagged = opt.all.some((v) => alt === v || altContainsValue(alt, v));
        if (isTagged && !altContainsValue(alt, opt.selected)) show = false;
      });

      item.classList.toggle('variant-media-hidden', !show);
    });
  }

  // -- Sync dots to match visible slides ------------------------------------

  function syncDots() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;

    const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
    if (!slides.length) return;

    const dotItems = Array.from(slideshow.querySelectorAll('.slideshow-controls__dot-item'));
    if (!dotItems.length) return;

    dotItems.forEach((li) => {
      const idx = parseInt(li.dataset.dotIndex, 10);
      const slide = slides[idx];
      const hidden = slide ? slide.classList.contains('variant-media-hidden') : false;
      if (hidden) {
        li.setAttribute('hidden', '');
      } else {
        li.removeAttribute('hidden');
      }
    });

    // Mark dots as ready — removes the visibility:hidden that prevents flash
    const dotLists = slideshow.querySelectorAll('.slideshow-controls__dots');
    dotLists.forEach((ol) => ol.setAttribute('data-dots-ready', ''));
  }

  // -- Gallery update --------------------------------------------------------

  function filterGallery() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const options = buildOptions();

    const mainItems  = Array.from(gallery.querySelectorAll('li.product-media-container, slideshow-slide'));
    const thumbItems = Array.from(gallery.querySelectorAll('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail'));

    applyFilter(mainItems,  options);
    applyFilter(thumbItems, options);

    syncDots();
  }

  // -- Hide dots immediately before any render ------------------------------
  // Inject a <style> tag as early as possible so dots are invisible until
  // syncDots() adds data-dots-ready. This eliminates the flash of all dots.

  function injectEarlyStyle() {
    const style = document.createElement('style');
    style.textContent = '.slideshow-controls__dots:not([data-dots-ready]) { visibility: hidden; }';
    document.head.appendChild(style);
  }

  // -- Event wiring ----------------------------------------------------------

  function attachVariantPickerListener() {
    const picker = document.querySelector('variant-picker');
    if (!picker) return;
    picker.addEventListener('variant:update', () => {
      // Hide dots instantly while variant switches, then re-sync
      document.querySelectorAll('.slideshow-controls__dots').forEach((ol) => {
        ol.removeAttribute('data-dots-ready');
      });
      setTimeout(filterGallery, 50);
      setTimeout(filterGallery, 250);
      setTimeout(filterGallery, 500);
    });
  }

  function attachSectionObserver() {
    const section = document.querySelector('.shopify-section:has(media-gallery)');
    if (!section) return;
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeName === 'MEDIA-GALLERY') {
            setTimeout(filterGallery, 100);
            setTimeout(filterGallery, 400);
          }
        }
      }
    }).observe(section, { childList: true, subtree: false });
  }

  function init() {
    injectEarlyStyle();
    filterGallery();
    attachVariantPickerListener();
    attachSectionObserver();
  }

  // Run as early as possible — don't wait for DOMContentLoaded
  // so the style injection happens before dots are painted.
  if (document.head) {
    injectEarlyStyle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      filterGallery();
      attachVariantPickerListener();
      attachSectionObserver();
    });
  } else {
    init();
  }

})();
